{
  "name": "client",
  "version": "0.0.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 8700 --proxy-config proxy.conf.local.json",
    "start:test": "ng serve --port 8700 --proxy-config proxy.conf.test.json",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "test": "vitest run",
    "lint": "ng lint",
    "e2e:ui": "npx playwright test --ui",
    "e2e": "npx tsx ./playwright/scripts/setup-env.ts && npx playwright test",
    "e2e:headed": "npx tsx ./playwright/scripts/setup-env.ts && npx playwright test --headed"
  },
  "config": {
    "imageRepo": "portal/commercial",
    "imageName": "commercial",
    "imagePort": "8700",
    "internalContainerPort": "80",
    "production": true,
    "baseUrl": "https://localhost:5003"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.2.3",
    "@angular/cdk": "22.2.4",
    "@angular/common": "22.2.3",
    "@angular/compiler": "22.2.3",
    "@angular/core": "22.2.3",
    "@angular/forms": "22.2.3",
    "@angular/google-maps": "22.2.4",
    "@angular/localize": "22.2.3",
    "@angular/material": "22.2.4",
    "@angular/material-moment-adapter": "22.2.4",
    "@angular/platform-browser": "22.2.3",
    "@angular/platform-browser-dynamic": "22.2.3",
    "@angular/router": "22.2.3",
    "@angular/service-worker": "22.2.3",
    "@datadog/browser-rum": "^7.0.0",
    "@datadog/datadog-ci": "^5.13.0",
    "@firebase/app": "^0.16.0",
    "@firebase/firestore": "^4.9.2",
    "@ngneat/input-mask": "^6.1.0",
    "angular-oauth2-oidc": "^22.0.2",
    "chromedriver": "^156.0.0",
    "country-flag-emoji-polyfill": "^0.1.8",
    "echarts": "^6.1.0",
    "file-saver": "^2.0.5",
    "guid-typescript": "^1.0.9",
    "inputmask": "5.0.10",
    "jwt-decode": "^4.0.0",
    "libphonenumber-js": "^1.12.15",
    "moment": "^2.30.1",
    "ngx-echarts": "^22.0.0",
    "ok-angular-shared": "^22.2.9",
    "ok-ng-material": "^22.0.0",
    "rxjs": "~7.8.1",
    "rxjs-interop": "^2.0.0",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.6.4",
    "@analogjs/vitest-angular": "^2.7.5",
    "@angular-eslint/builder": "22.6.0",
    "@angular-eslint/eslint-plugin": "22.6.0",
    "@angular-eslint/eslint-plugin-template": "22.6.0",
    "@angular-eslint/schematics": "22.6.0",
    "@angular-eslint/template-parser": "22.6.0",
    "@angular/build": "22.2.4",
    "@angular/cli": "22.2.4",
    "@angular/compiler-cli": "22.2.3",
    "@angular/language-service": "22.2.3",
    "@dotenvx/dotenvx": "^2.0.0",
    "@emnapi/core": "^1.10.0",
    "@emnapi/runtime": "^1.10.0",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.52.0",
    "@types/inputmask": "^5.0.7",
    "@types/node": "^26.0.0",
    "@types/prompt-sync": "^4.2.3",
    "@typescript-eslint/eslint-plugin": "^8.42.0",
    "@typescript-eslint/parser": "^8.23.0",
    "@vitest/browser": "^5.0.0",
    "@vitest/browser-playwright": "^5.0.0",
    "@vitest/coverage-v8": "^5.0.0",
    "@vitest/ui": "^5.0.0",
    "angular-eslint": "^22.1.0",
    "cross-conf-env": "^1.3.0",
    "cross-env": "^10.0.0",
    "eslint": "^10.0.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "jsdom": "^30.0.0",
    "npm-run-all": "^4.1.5",
    "playwright": "^1.52.0",
    "prettier": "^3.6.6",
    "prompt-sync": "^4.2.0",
    "sass-embedded": "^1.93.2",
    "tsx": "^4.19.3",
    "typescript": "~6.0.2",
    "vitest": "^5.0.0"
  },
  "overrides": {
    "@grpc/grpc-js": "1.14.6"
  },
  "allowScripts": {
    "ok-angular-shared@22.2.8": true
  }
}
